export default {"src":"https://webcdn.trailways.com/_next/static/media/youtube.20fa4025.svg","height":20,"width":29,"blurWidth":0,"blurHeight":0};